var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("AFFILIATED HOSPITALS")]),_c('h4',[_vm._v(" A duly licensed hospital included in the list of affiliated hospitals of HMI with which the HMI has an existing and valid service agreement and where a Member can avail of medical services pursuant to this Agreement. ")])])
}]

export { render, staticRenderFns }